import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
@classNames('footer')
export default class SharedSideFlyoutFooter extends Component {}
